import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from '@telus-uds/components-web';

const OrderButton = ({ button, isOrderValidating, isValidated }) => {
  const { label, onClick, variant, isVisibleOnValidate } = button;

  // Map TDS variants to UDS variants
  const udsVariant = variant === 'green' ? undefined : variant === 'purple' ? { priority: 'low' } : variant;

  return (
    <Spinner label={label} variant={{ size: 'small' }} show={isOrderValidating} inline>
      <Button
        type="button"
        variant={udsVariant}
        disabled={isValidated && isVisibleOnValidate}
        onPress={onClick}
      >
        {label}
      </Button>
    </Spinner>
  );
};

OrderButton.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    isVisibleOnValidate: PropTypes.bool
  }).isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isValidated: PropTypes.bool.isRequired
};

export default OrderButton;
